import { render, staticRenderFns } from "./QualifiedList.vue?vue&type=template&id=60b5cb75&scoped=true&"
import script from "./QualifiedList.vue?vue&type=script&lang=js&"
export * from "./QualifiedList.vue?vue&type=script&lang=js&"
import style0 from "./QualifiedList.vue?vue&type=style&index=0&id=60b5cb75&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b5cb75",
  null
  
)

export default component.exports